// @flow

/* Libs */
import React from 'react';
import { useMediaQuery } from 'react-responsive';

import useApplicationStore from 'Stores/Application';

import Icon from 'Components/Icon';

/* Styles */
import './Header.scss';

const Header = (props) => {
	const {
		title, actions, children
	} = props;
	const isMobile = useMediaQuery({ query: `(max-width: ${Constants.RESPONSIVE_SM}px)` });
	const showSidebar = useApplicationStore(store => store.showSidebar);
	const setShowSidebar = useApplicationStore(store => store.setShowSidebar);

	return (
		<header className="App-Header">
			<div className="header">
				<div className="header-title">
					{ isMobile && (
						<div className="burger-menu">
							<Icon isHM name="utilitary_menu" onClick={() => setShowSidebar(!showSidebar)} />
						</div>
					)}
					<h2>{ title }</h2>
				</div>
				{ actions && (
					<div className="header-actions">
						{ actions.map(action => (
							<div
								key={Math.random()}
								className="action"
								onClick={action.callback}
								role="button"
								tabIndex="0"
							>
								{ action.icon && (<Icon {...action.icon} hasHover />) }
								{ action.label }
							</div>
						))}
					</div>
				)}
			</div>
			{ children }
		</header>
	);
};

Header.propTypes = {
	title: PropTypes.string.isRequired,
	actions: PropTypes.arrayOf(PropTypes.shape())
};

Header.defaultProps = {
	actions: null
};

export default Header;
